interface DadosNaoCarregadosProps {
  mensagem?: string;
  tentarNovamente?: () => void;
}

export default function DadosNaoCarregados({ 
  mensagem = "Não foi possível carregar os dados necessários.", 
  tentarNovamente 
}: DadosNaoCarregadosProps) {
  return (
    <div className="container mt-5">
      <div className="alert alert-warning">
        <h4 className="alert-heading">Atenção!</h4>
        <p>{mensagem}</p>
        {tentarNovamente && (
          <button 
            className="btn btn-warning mt-3"
            onClick={tentarNovamente}
          >
            Tentar Novamente
          </button>
        )}
      </div>
    </div>
  );
}
